module.exports = __webpack_public_path__ + "img/13.2f1b79be.jpg";